import Banner from './Banner';

const titleize = name =>
  name
    .split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .trim();

export default class BannerName {
  constructor(
    protected banner: Banner,
    protected previous: string
  ) {
    //
  }

  public toString(): string {
    const basename = this.banner.basename();

    if (!/^index$/i.test(basename)) {
      // the banner has a name we can turn into a decent looking title
      const title = titleize(this.previous);

      if (title) {
        return title;
      }
    }

    if (this.banner.isEspnUap()) {
      return this.banner.espnUapInfo().label;
    }

    // Attempts to make the banner pretty failed.
    return this.banner.basename();
  }
}
